module.exports = __webpack_public_path__ + "static/img/page33.c51b6f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page33.jpg
// module id = lUY4
// module chunks = 0